import React from 'react';
import { resolveBrandName } from '../../utils/brandLabel';

interface BrandChipProps {
  brandName?: string;
  brandId?: string;
  brandLookup?: Map<string, string>;
  size?: 'xs' | 'sm';
}

export const BrandChip: React.FC<BrandChipProps> = ({
  brandName,
  brandId,
  brandLookup,
  size = 'sm',
}) => {
  const label = resolveBrandName({}, brandLookup, brandId, brandName);
  const padding = size === 'xs' ? 'px-2 py-0.5 text-[10px]' : 'px-2.5 py-1 text-[11px]';
  return (
    <span className={`inline-flex items-center gap-1 rounded-full bg-teal-50 text-teal-700 border border-teal-100 font-bold whitespace-nowrap ${padding}`}>
      {label}
    </span>
  );
};
